import { styled } from '@mui/material'

export const DialogImage = styled('img')(() => ({
  objectFit: 'contain',
  maxHeight: '80vh',
  maxWidth: '100%',
}))
